import http from "./http.js";
import moment from "moment";
import _ from "lodash";
moment.locale("uk");

async function balanceUpdateReport(filterParams) {
  try {
    const {
      clientId,
      dateFrom,
      dateTo,
      projectId,
      withoutBonuses,
    } = filterParams;
    const response = await http.get("reports/balance", {
      params: {
        clientId,
        projectId,
        from: dateFrom,
        to: dateTo,
        withoutBonuses,
      },
    });

    return response.data.map((i) => {
      return {
        month: moment(i.month).format("MMMM YY"),
        startMonthBalance: i.startMonthBalance,
        payedHours: i.payedHours,
        spentHours: i.spentHours,
        bonusHours: i.bonusHours,
        endMonthBalance: i.endMonthBalance,
        servicesHours: i.servicesHours,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function debtGetData(managerId, dateIn) {
  try {
    const response = await http.get("reports/debt", {
      params: {
        manager: managerId,
        date: dateIn,
      },
    });
    return response.data.map((i) => {
      return {
        client: {
          title: i.client.title,
          id: i.client.id,
        },
        balance: i.balance,
        manager: i.manager?.title || "",
      };
    });
  } catch (err) {
    throw err;
  }
}

async function packagesUpdateReport(queryParams) {
  try {
    const response = await http.get("reports/packages-to-prolongation", {
      params: queryParams,
    });
    return response.data.map((i) => {
      return {
        client: { id: i.client.id, title: i.client.title },
        prevPayments: i.prevPayments
          ? i.prevPayments.map((p) => {
            return {
              date: moment(p.date).format("DD.MM.YY"),
              hours: p.hours,
              package: p.package
                ? {
                  id: p.package.id,
                  title: p.package.title,
                }
                : null,
            };
          })
          : [],
        recommendedPackage: i.recommendedPackage
          ? {
            id: i.recommendedPackage.id,
            title: i.recommendedPackage.title,
          }
          : null,
        nextPaymentDate: i.nextPaymentDate,
        currentBalanceHours: i.currentBalanceHours,
        spentHours: i.spentHours,
        recommendedHours: i.recommendedHours,
        paymentAmount: i.paymentAmount,
        lastInvoice: i.lastInvoice
          ? {
            ...i.lastInvoice,
            date: moment(i.lastInvoice.date).format("DD.MM.YY"),
          }
          : null,
        manager: i.manager
          ? {
            id: i.manager.id,
            title: i.manager.title,
          }
          : null,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function packagesUpdateReportOld(managerId, date) {
  try {
    const response = await http.get("reports/packages-to-prolongation-old", {
      params: {
        managerId: managerId ? managerId : "",
        date: date ? date : "",
      },
    });
    return response.data.map((i) => {
      return {
        client: { id: i.client.id, title: i.client.title },
        prevPackage: i.prevPackage
          ? {
            id: i.prevPackage.id,
            title: i.prevPackage.title,
          }
          : null,
        prevPayedHours: i.prevPayedHours,
        prevPaymentDate: i.prevPaymentDate,
        recommendedPackage: i.recommendedPackage
          ? {
            id: i.recommendedPackage.id,
            title: i.recommendedPackage.title,
          }
          : null,
        nextPaymentDate: i.nextPaymentDate,
        currentBalanceHours: i.currentBalanceHours,
        spentHours: i.spentHours,
        recommendedHours: i.recommendedHours,
        paymentAmount: i.paymentAmount,
        lastInvoice: i.lastInvoice
          ? {
            ...i.lastInvoice,
            date: moment(i.lastInvoice.date).format("DD.MM.YY"),
          }
          : null,
        manager: i.manager
          ? {
            id: i.manager.id,
            title: i.manager.title,
          }
          : null,
        packageArticle: i.packageArticle,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function getServicesToProlongation(
    managerId,
    clientId,
    onlyStopped,
    serviceTypeId,
    onlyOverdueService,
    dateFrom,
    dateTo,
) {
  try {
    const response = await http.get("reports/services-to-prolongation", {
      params: {
        managerId,
        clientId,
        onlyStopped,
        serviceTypeId,
        onlyOverdueService,
        dateFrom,
        dateTo,
      },
    });
    return response.data.map((i) => {
      return {
        service: { id: i.service.id, title: i.service.title, shortTitle: i.service.shortTitle },
        client: { id: i.client.id, title: i.client.title },
        manager: i.manager
          ? { id: i.manager.id, title: i.manager.title }
          : null,
        payedTo: i.payedTo,
        remainingDays: i.remainingDays,
        quantity: i.quantity,
        stoppedService: i.stoppedService,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function worklogUpdateReport({ clientId, projectId, dateFrom, dateTo }) {
  try {
    const response = await http.get("reports/worklog", {
      params: {
        from: dateFrom,
        to: dateTo,
        clientId,
        projectId,
      },
    });
    return response.data.map((w) => {
      return {
        key: w.issue.key,
        numberedKey: _.toString(_.takeRight(_.words(w.issue.key))),
        summary: w.issue.summary,
        issueAuthor: w.issue.author,
        status: w.issue.status,
        dueDate: w.issue.dueDate
          ? moment(w.issue.dueDate).format("DD.MM.YY")
          : "",
        description: w.issue.description,
        customerDescription: w.issue.customerDescription,
        employee: w.employee,
        timeSpentSeconds: w.timeSpentSeconds,
        payedSeconds: w.payedSeconds,
        payedHours: w.payedHours,
        comment: w.comment || "",
        date: moment(w.date).format("DD.MM.YY"),
        project: w.issue.project,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function getManagersBonuses(month) {
  try {
    const response = await http.get(`reports/managers-bonuses?month=${month}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getWorklogSummary(from, to) {
  const params = {};
  if (from) {
    params.from = from;
  }
  if (to) {
    params.to = to;
  }
  try {
    const response = await http.get("reports/worklog-summary", { params });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getEmployeesGrades({ date, clientId, employeeId }) {
  try {
    const response = await http.get("reports/employees-grades", {
      params: {
        date,
        clientId,
        employeeId,
      },
    });
    return response.data.map((g) => {
      return {
        employee: g.employee
          ? {
            id: g.employee.id,
            title: g.employee.title,
          }
          : null,
        project: g.project
          ? {
            id: g.project.id,
            title: g.project.title,
          }
          : null,
        grade: g.grade,
      };
    });
  } catch (err) {
    throw err;
  }
}

export {
  balanceUpdateReport,
  debtGetData,
  packagesUpdateReport,
  packagesUpdateReportOld,
  getServicesToProlongation,
  worklogUpdateReport,
  getManagersBonuses,
  getWorklogSummary,
  getEmployeesGrades,
};
